<formio
  #formView
  class="d-block"
  [ngClass]="{ 'modal-version': modalView, 'editable-version': editable }"
  [form]="formObj"
  [submission]="submissionObj"
  [readOnly]="!editable"
  (submit)="onSubmit($event)"
  appDomChangeListener
  (domChanged)="onDomChange($event)"
  (change)="onFormChange($event)"
>
</formio>
